<template>
  <div class="search-sidebar--single">
    <h3 class="filter--title">{{ $t('general.filter.propertyType') }}</h3>
    <!--    <v-select-->
    <!--      v-model="selectedPropertyType"-->
    <!--      :items="propertyTypes"-->
    <!--      :label="$t('general.filter.propertyType')"-->
    <!--      item-value="id"-->
    <!--      item-text="name"-->
    <!--      solo-->
    <!--      hide-details-->
    <!--      return-object-->
    <!--    ></v-select>-->
    <div class="property--type-filter">
      <div
        class="property--type"
        :class="{
          selected:
            selectedPropertyTypes &&
            selectedPropertyTypes.find(function (item) {
              return item.id === propertyType.id;
            }),
        }"
        :style="{ display: propertyType.id == null ? 'none' : 'flex' }"
        @click="choose(propertyType)"
        v-for="(propertyType, index) in displayPropertyTypes"
        :key="`property-type-${index}`"
      >
        <img v-if="getPropertyTypeImage(propertyType)" :src="getPropertyTypeImage(propertyType)" />
        <div>{{ propertyType.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchMixin from '@/mixins/searchMixin';
import LodashMixin from '@/mixins/lodash';
import { mapGetters, mapState } from 'vuex';

export default {
  mixins: [SearchMixin, LodashMixin],
  components: {},
  computed: {
    ...mapState({
      isLoading: (state) => state.searchListing.isLoading,
      propertyTypes: (state) => state.masters.propertyTypes,
    }),
    ...mapGetters({
      propertyTypesByListingType: 'masters/propertyTypesByListingType',
    }),
    selectedPropertyTypes: {
      get() {
        return this.$store.state.searchListing.selectedPropertyTypes;
      },
      set(value) {
        this.$store.dispatch('searchListing/setPropertyTypes', {
          payload: value,
          query: this.$route.query,
        });
      },
    },
    displayPropertyTypes() {
      const sortOrder = [1, 7, 2, 3, 11, 4, 5, 6, 12, 9, 10, 13];
      return [...this.propertyTypesByListingType].sort((a, b) => {
        const aIndex = sortOrder.indexOf(a.id);
        const bIndex = sortOrder.indexOf(b.id);
        if (aIndex === -1 && bIndex === -1) return 0;
        if (aIndex === -1) return 1;
        if (bIndex === -1) return -1;
        return aIndex - bIndex;
      });
    },
  },
  data: () => ({}),
  methods: {
    getPropertyTypeImage(propertyType) {
      const baseCdnUrl = 'https://beliruma.s3.ap-southeast-1.amazonaws.com';
      const imageMap = {
        1: 'house.svg',
        2: 'apartment.svg',
        3: 'warehouse.svg',
        4: 'shophouse.svg',
        5: 'residential-land.svg',
        6: 'commercial-land.svg',
        7: 'working-space.svg',
        9: 'villa.svg',
        10: 'building.svg',
        11: 'office.svg',
        12: 'factory.svg',
        13: 'commercial-land.svg',
        14: 'kost.svg',
        15: 'hotel.svg',
      };
      const imageName = imageMap[propertyType.id];
      return imageName ? `${baseCdnUrl}/public/static/img/property-type/v2/${imageName}` : null;
    },
    choose(propertyType) {
      if (
        this.selectedPropertyTypes &&
        this.selectedPropertyTypes.find(function (item) {
          return item.id === propertyType.id;
        })
      ) {
        this.selectedPropertyTypes = this.selectedPropertyTypes.filter(
          (item) => item.id !== propertyType.id,
        );
      } else {
        this.selectedPropertyTypes.push(propertyType);
      }

      // APPLY FILTER ON SELECT PROPERTY TYPE
      if (this.$mq !== 'xs') {
        this.$store.dispatch('searchListing/goToSearchPage', {
          router: this.$router,
          params: this.$route.params,
        });
      }
    },
  },
};
</script>
